import createAppSlice from 'state/createAppSlice'

import { Loading } from 'types/shared'

export type LoadingState = Loading

export const loadingInitialState: LoadingState = {
  active: false
}

export const { reducer: loadingReducer, actions: loadingActions } =
  createAppSlice({
    name: 'Loading',
    initialState: loadingInitialState,
    reducers: (create) => ({
      startLoading: create.preparedReducer(
        ({ des, complement }: { des: string; complement?: string }) => ({
          payload: { des, complement }
        }),
        (state, action) => ({
          ...state,
          active: true,
          des: action.payload.des,
          complement: action.payload.complement
        })
      ),

      stopLoading: create.reducer((state) => ({
        ...state,
        active: false,
        des: undefined,
        complement: undefined
      }))
    })
  })

export default loadingReducer
